import React from "react";
import { useTranslation } from "react-i18next";
import { Tag as T } from "@planzone/dto";

import { TagIcon } from "@common/assets/tagIcon";
import { Loader } from "../loader";
import { Section } from "../section";
import { ScrollPane } from "../scrollPane";
import { filterSearch } from "../utils";
import { Props } from "./types";
import { Tag } from "./tag";
import { useResourceTags } from "./utils";
import styles from "./styles.scss";

function ResourceTags({ search, filter, setFilter, isOpen }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, tags } = useResourceTags();
  const selectTag = (resource: T) =>
    setFilter(filter ? [...filter, resource] : [resource]);
  const unSelectTag = ({ name }: T) =>
    filter && setFilter(filter.filter((tag) => tag.name !== name));

  return (
    <Section
      header={
        <div className={styles.header}>
          <TagIcon className={styles.icon} />
          <p className={styles.title}>
            {t("common.filterMenu.resourceTags.title")}
          </p>
        </div>
      }
      list={
        <ScrollPane>
          <div className={styles.list}>
            {!isRequestPending ? (
              [...filterSearch(tags, search)]
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((tag) => (
                  <Tag
                    key={tag.name}
                    tag={tag}
                    isSelected={
                      !!filter && !!filter.find(({ name }) => name === tag.name)
                    }
                    select={() => selectTag(tag)}
                    unSelect={() => unSelectTag(tag)}
                  />
                ))
            ) : (
              <Loader />
            )}
          </div>
        </ScrollPane>
      }
      isOpen={isOpen}
    />
  );
}

export { ResourceTags };
